export default function About() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            关于海角网
          </h2>
          <div className="mt-8 space-y-4 text-sm md:text-base text-foreground-600 leading-relaxed">
            <p>
              <strong className="text-foreground-900">海角网</strong>是一个汇聚千万原创内容的综合社区平台，
              致力于为创作者和观众搭建最优质的交流桥梁。平台涵盖<strong className="text-foreground-900">海角视频</strong>、
              <strong className="text-foreground-900">海角社区</strong>、<strong className="text-foreground-900">海角论坛</strong>
              三大核心板块，每日更新海量新鲜内容。
            </p>
            <p>
              自成立以来，海角网始终秉持开放、包容、创新的理念，聚集了来自全国各地的优秀创作者和活跃用户。
              无论你是热衷于观看精彩视频，还是喜欢参与深度讨论，亦或是想要分享自己的原创作品，
              海角网都能为你提供最舒适的体验和最广阔的空间。
            </p>
            <p>
              海角社定期策划各类主题活动和专题合集，让用户在海角在线发现更多感兴趣的内容。
              海角网址入口稳定可靠，海角官网持续优化升级，确保每一位访客都能顺畅访问海角网免费看的内容资源。
            </p>
          </div>

          <div className="mt-8 inline-flex items-center gap-6 px-6 py-4 bg-background-100 rounded-xl border border-background-200/70">
            <div className="text-center">
              <div className="text-lg font-heading font-bold text-primary-600">1000万+</div>
              <div className="text-xs text-foreground-500 mt-0.5">原创作品</div>
            </div>
            <div className="w-px h-8 bg-background-300/60"></div>
            <div className="text-center">
              <div className="text-lg font-heading font-bold text-accent-600">500万+</div>
              <div className="text-xs text-foreground-500 mt-0.5">社区成员</div>
            </div>
            <div className="w-px h-8 bg-background-300/60"></div>
            <div className="text-center">
              <div className="text-lg font-heading font-bold text-primary-600">99.9%</div>
              <div className="text-xs text-foreground-500 mt-0.5">在线率</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}